import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.institute.user.issue.edit');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';
import moment from "moment";
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";
import { ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-institute-user-issue-edit',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.institute.user.issue.edit/view.scss */
/* src/app/portal.institute.user.issue.edit/view.scss: no such file or directory */`],
})
export class PortalInstituteUserIssueEditComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title,@Inject( Router)  private router: Router) { }

    @Input() insID: any;
    @Input() mode: any;

    @ViewChild('editor')
    public editorElement: ElementRef;

    public issue: any = {
        title: '',
        description: '',
        priority: '',
        attachments: []
    };
    public editor: any;
    public priorities = [
        { label: '낮음', value: 'low' },
        { label: '보통', value: 'middle' },
        { label: '높음', value: 'high' }
    ];

    public fd = new FormData();
    private allowedExt = [
        'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt',
        'png', 'jpg', 'jpeg', 'gif', 'webp'
    ];
    private maxSize = 10 * 1024 * 1024; // 10MB

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle("기관 이슈 작성 - MY KREONET");
        await this.buildEditor();
    }

    public async submit() {
        if (!this.issue.priority || this.issue.priority == "") return await this.service.alert.warning("우선순위를 선택해주세요.");
        if (!this.issue.title || this.issue.title == "") return await this.service.alert.warning("이슈 제목을 작성해주세요.");
        this.issue.description = this.editor.data.get();
        if (!this.issue.description || this.issue.description == "") return await this.service.alert.warning("이슈 내용을 작성해주세요.");

        this.issue.ins_id = this.insID;
        // const { code, data } = await wiz.call("submit", this.issue);
        let url = wiz.url('submit')
        this.fd.append('issue', JSON.stringify(this.issue))
        const { code, data } = await this.service.file.upload(url, this.fd);
        if (code != 200) return await this.service.alert.error("Error!");
        await this.service.alert.success("새로운 이슈가 등록되었습니다.");
        await this.router.navigate([`/institutes/${this.insID}/issue`]);
    }

    public async buildEditor() {
        // let editor = this.editor = await ClassicEditor.create(this.editorElement.nativeElement, {
        let editor = this.editor = await ClassicEditor.create(document.querySelector("textarea#editor"), {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    // '|', 'alignment',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    // '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                // items: 'heading | bold italic strikethrough underline | fontColor highlight fontBackgroundColor | bulletedList numberedList todoList | outdent indent | insertTable | link blockQuote code codeBlock'.split(' '),
                shouldNotGroupWhenFull: true
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar", "Markdown"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });

        this.editor.editing.view.change(writer => {
            writer.setStyle(
                "min-height",
                "300px",   // 원하는 높이
                editor.editing.view.document.getRoot()
            );
        });

        this.editor.data.set(this.issue.description);
        // console.log("Builtin plugins:", ClassicEditor.builtinPlugins?.map(p => p.pluginName));
        // console.log("Available toolbar components:", Array.from(editor.ui.componentFactory.names()));
    }

    public async fileUpload(e) {
        for (let i = 0; i < e.target.files.length; i++) {
            let file = e.target.files[i]
            this.filename = file.name;
            if (!file.filepath) file.filepath = file.name;
            this.fd.append('file[]', file);
            let info = { name: file.name, size: file.size }
            this.issue.attachments.push(info);
        }
        console.log("attchment : ", this.issue.attachments);
        await this.service.render();
    }

    // (선택) 드래그&드롭 지원을 추가하고 싶으면 템플릿에 (drop)/(dragover) 바인딩 후 이 메서드 사용
    public handleDropFiles(files: FileList | File[]) {
        this.addFiles(files);
    }

    public removeAttachment(index: number) {
        this.issue.attachments = this.issue.attachments.filter((_, i) => i !== index);
    }

    public formatFileSize(bytes: number) {
        if (!Number.isFinite(bytes)) return '-';
        const units = ['B', 'KB', 'MB', 'GB'];
        let i = 0, size = bytes;
        while (size >= 1024 && i < units.length - 1) { size /= 1024; i++; }
        return `${Math.round(size * 100) / 100} ${units[i]}`;
    }

    public getFileIcon(filename: string) {
        const ext = this.getExt(filename);
        switch (ext) {
            case 'pdf': return '📕';
            case 'doc':
            case 'docx': return '📝';
            case 'xls':
            case 'xlsx': return '📊';
            case 'ppt':
            case 'pptx': return '📈';
            case 'txt': return '📄';
            case 'png':
            case 'jpg':
            case 'jpeg':
            case 'gif':
            case 'webp': return '🖼️';
            default: return '📦';
        }
    }

    private getExt(name: string): string | null {
        const i = name.lastIndexOf('.');
        return i >= 0 ? name.slice(i + 1).toLowerCase() : null;
    }
}

export default PortalInstituteUserIssueEditComponent;